export const FORMS = {
    BASIC_INFO: 'BASIC_INFO',
    HEALTH: 'HEALTH',
    SENSITIVE_INFORMATION: 'SENSITIVE_INFORMATION',
    REGISTRATION: 'REGISTRATION',
};

export const PORTAL = 'ABOUT_PORTAL';

export const QUERY_PARAMS = {
    ACTIVE_TAB: {
        BASIC_INFO: 'BASIC_INFO',
        HEALTH: 'HEALTH',
        SENSITIVE_INFORMATION: 'SENSITIVE_INFORMATION',
        REGISTRATION: 'REGISTRATION',
        PERMISSIONS: 'permissions',
        CHILD_PROFILE_TAGS_TAB: 'childProfileTagsTab',
        KIBIG: 'kibig',
        DATA_MANAGEMENT: 'DATA_MANAGEMENT',
    },
};
